// Bridge section — only bridge endpoints.
import { api, uploadToS3 } from "@/core/api/client";
import type { BridgeEvidence, UpdateBridgeEvidenceRequest } from "@/core/api/types";

export async function requestBridgeLetterUpload(reportId: string, file: File): Promise<void> {
  const presign = await api.post<{ upload_url: string; upload_fields: Record<string, string> }>(
    `/reports/${reportId}/bridge-letter`
  );
  await uploadToS3(presign.upload_url, presign.upload_fields, file);
}

export async function getBridgeEvidence(reportId: string): Promise<BridgeEvidence | null> {
  const data = await api.get<{ bridge_evidence: BridgeEvidence | null }>(
    `/reports/${reportId}/bridge-evidence`
  );
  return data.bridge_evidence;
}

export async function updateBridgeEvidence(
  reportId: string,
  req: UpdateBridgeEvidenceRequest
): Promise<BridgeEvidence> {
  const data = await api.patch<{ bridge_evidence: BridgeEvidence }>(
    `/reports/${reportId}/bridge-evidence`,
    req
  );
  return data.bridge_evidence;
}
